var link_viewer_default = {
  "fontElementMap": "SC4V0",
  "link": "zu0n-",
  "linkInEditor": "WiKvL",
  "linkInViewer": "Iz2UI",
  "toolbarUrlContainer": "_1vdDV",
  "toolbarUrl": "_7Igbk",
  "toolbarUrlAnchor": "p99pf"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
